"use client";

import { createContext } from "react";

export interface ChatJsonRenderContextValue {
  chatId?: string;
  streamLoading?: boolean;
  collapsed?: boolean;
  metrics?: string;
  notificationId?: string;
}

const ChatJsonRenderContext = createContext<ChatJsonRenderContextValue | null>(
  null,
);

interface ChatJsonRenderContextProviderProps {
  value?: ChatJsonRenderContextValue;
  children: React.ReactNode;
}

export const ChatJsonRenderContextProvider: React.FC<
  ChatJsonRenderContextProviderProps
> = ({ value, children }) => (
  <ChatJsonRenderContext.Provider value={value ?? null}>
    {children}
  </ChatJsonRenderContext.Provider>
);
